import { useContext } from 'react';
import { useParams, useNavigate, Navigate  } from 'react-router-dom';

// import {
//   useMediaQuery,
// } from '@chakra-ui/react';

import * as Components from 'view-layer/components';
import useFetch, { FetchResult } from 'data-layer/fetch-api/useFetch';
import { PaymentRequestService } from 'data-layer/services/PaymentRequestService';
import { PaymentDataDto, LinkStatus } from 'data-layer/dto';
import { PaymentContext } from 'business-layer/contexts/PaymentContext';
import { useDocumentTitle } from 'business-layer/hooks/useDocumentTitle';
import { parseBillingAddressFields } from 'business-layer/helpers/billing';
import { LayoutContainer } from 'view-layer/components/layout/LayoutContainer';
import { CardDeclined } from 'view-layer/components/layout/statuses/CardDeclined';
import { Box } from '@chakra-ui/react';

interface MainProps {
  declined?: boolean
}

export const Main = ({ declined=false }: MainProps) => {
  const { hash = '' } = useParams();
  useDocumentTitle('');

  // const [ isDesktop ] = useMediaQuery('(min-width: 992px)');
  const navigate = useNavigate();
  const [ data, loading, error ]: FetchResult<PaymentDataDto> = useFetch(PaymentRequestService(hash), PaymentDataDto, hash);
  const { billingAddressFields, paymentMethods } = useContext(PaymentContext) as any;

  const billing = parseBillingAddressFields(billingAddressFields);

  const { status } = data?.payment || {};
  // const isCompleted = status === LinkStatus.Completed;
  const isPaid = status === LinkStatus.Paid;
  const isExpired = status === LinkStatus.Expired;
  const isProcessing = status === LinkStatus.Processing;
  const isCancelled = status === LinkStatus.Cancelled;

  if (isPaid) {
    const paidUrl = `/payment/${hash}/completed`;
    return (
      <Navigate to={paidUrl} replace={true} />
    );
  }

  if (isExpired || isCancelled) {
    const expiredUrl = `/payment/${hash}/expired`;
    return (
      <Navigate to={expiredUrl} replace={true} />
    );
  }
  // localhost:3000/#/payment/7waSpI.296c568d-41b5-495f-948b-641cc401d309
  // if (isProcessing) {
  //   const message = 'We are sorry, but we can\'t fulfill your request at the moment.'
  //   return (
  //     <Navigate to="/error" state={{ message }} replace={true} />
  //   );
  // }

  if (isProcessing) { // TODO: refine 3ds flow if auth not completed
    const processingUrl = `/payment/${hash}/pending`;
    return (
      <Navigate to={processingUrl} replace={true} />
    );
  }

  const handleError = (error: string): void => {
    navigate('/error', { state: { message: error }});
  };

  if (loading) {
    return (
      <Components.Common.Loader />
    );
  }

  if (data?.payment.reservationId === null) {
    return <Components.Layout.MessagePanel message={'We are sorry, but we can\'t find your payment details.'} />;
  }
  if (!!error) {
    const errorMessage = typeof error === 'string' ? error : 'Something went wrong, please try again later.';
    return <Components.Layout.MessagePanel message={errorMessage} />;
  }

  // const formPane: JSX.Element = (
  //   <Components.Layout.BasePanel payment={data?.payment} withActions>
  //     <Components.Forms.Form
  //       billing={billing}
  //       payment={data?.payment}
  //       onCriticalError={handleError}
  //     />
  //   </Components.Layout.BasePanel>
  // );

  // const sidePane: JSX.Element = (
  //   <Components.Layout.InfoPanel payment={{ ...data?.payment, ...data?.property}} />
  // );

  // const wSize = isCompleted ? 'md' : '960px';

  // const panes: JSX.Element[] = (isCompleted) ? [sidePane] : [sidePane, formPane];

  // const variant = isDesktop ? 'rows' : 'columns';

  return (
    <LayoutContainer payment={{ ...data?.payment, ...data?.property}} withActions>
      {declined && (
        <Box mb={6}>
          <CardDeclined single={ Array.isArray(paymentMethods) && paymentMethods.length === 1}/>
        </Box>
      )}
      <Components.Forms.Form
        billing={billing}
        payment={data?.payment}
        apiKey={`pbl.${data?.paymentElementApiKey}`}
        propertyId={data?.property.propertyId}
        onCriticalError={handleError}
      />
    </LayoutContainer>
  );
}
